import { createAsyncThunk } from '@reduxjs/toolkit';
import PropertyReconciliationResource from 'api/service/PropertyReconciliationResource';

export const listReconciliationProperties = createAsyncThunk(
  'reconciliation/listReconciliationProperties',
  async (initialData, { rejectWithValue }) => {
    const propertyReconciliationResource = new PropertyReconciliationResource();

    const params = {
      ...initialData,
      size: 15,
      offset: 0,
    };

    const { status, data } = await propertyReconciliationResource.search(params);
    if (status === 200) {
      return { data: data || [], offset: 15 };
    }
    return rejectWithValue('Error fetching reconciliation properties');
  }
);

export const listReconciliationPropertiesNext = createAsyncThunk(
  'reconciliation/listReconciliationPropertiesNext',
  async (initialData, { rejectWithValue }) => {
    const propertyReconciliationResource = new PropertyReconciliationResource();
    const { offset = 0 } = initialData;

    const params = {
      ...initialData,
      size: 15,
    };

    const { status, data } = await propertyReconciliationResource.search(params);
    if (status === 200) {
      return { data: data || [], offset: offset + 15 };
    }
    return rejectWithValue('Error fetching reconciliation properties');
  }
);
